<template>
  <el-row class="table_like_area" :gutter="gutter">
    <el-col v-for="(col, indexColumn) in columns" :key="indexColumn" :span="24 / columns.length">
      <div class="info-detail">
        <div class="info-detail-row" v-for="(row, indexRow) in col" :key="indexRow">
          <div class="info-detail-row-label" :style="{ width: labelWidth + 'px' }">
            {{ row.label }}
          </div>
          <div class="info-detail-row-value">{{ row.value }}</div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'TableLikeArea',

  props: {
    gutter: {
      type: Number,
      default: 20
    },
    // 二维数组
    columns: {
      type: Array,
      required: true
    },
    labelWidth: {
      type: Number,
      default: 108
    }
  }
};
</script>

<style scoped lang="scss">
$height-table-cell: 38px;

.table_like_area {
  .info {
    &-detail {
      display: table;

      &-row {
        display: table-row;
        font-size: 14px;
        margin-top: 23px;

        &-label {
          display: table-cell;
          height: $height-table-cell;
          vertical-align: middle;
          color: #555;
        }

        &-value {
          display: table-cell;
          height: $height-table-cell;
          vertical-align: middle;
          color: #333;
        }
      }
    }
  }
}
</style>
